import BaseIncomingPayload from "./base-incoming-payload.ts";
import IncomingPayloadEvent from "../../enums/incoming-payload-event.ts";
import ParseUtils from "../../utils/parse-utils.ts";

export default class V1GotRestaurantCategories extends BaseIncomingPayload {
  public readonly payload: V1GotRestaurantCategoriesPayload;

  constructor(payload: Record<string, unknown>) {
    super(payload, IncomingPayloadEvent.V1_GOT_RESTAURANT_CATEGORIES);

    this.payload = new V1GotRestaurantCategoriesPayload(ParseUtils.parseObject(payload, "payload"));
  }
}

export class V1GotRestaurantCategoriesPayload {
  public readonly categories: string[];

  constructor(payload: Record<string, unknown>) {
    this.categories = ParseUtils.parseStringArray(payload, "categories");
  }
}
